/**
 * ExploreTab — same signal data as Briefing, grouped into 7 marketer-managed
 * themes. Flowing scroll content; no sub-nav (removed per Phase-1 review).
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import type { MarketerViewData, ScoreNode } from '../types';
import { THEME } from '../config/theme';
import { ThemeSection } from './ThemeSection';

export interface ExploreTabProps {
  data: MarketerViewData;
  onOpen: (node: ScoreNode) => void;
}

export const ExploreTab: React.FunctionComponent<ExploreTabProps> = ({
  data,
  onOpen,
}) => (
  <main style={{ padding: '0 0 32px' }}>
    <div style={{ maxWidth: 760, padding: '4px 0 4px' }}>
      <h2
        style={{
          fontSize: 22,
          fontWeight: 600,
          color: THEME.textBase,
          letterSpacing: '-0.01em',
          margin: 0,
        }}
      >
        <FormattedMessage
          id="marketerView.explore.title"
          defaultMessage="Your brand, by area"
        />
      </h2>
      <p
        style={{
          fontSize: 14,
          lineHeight: 1.6,
          color: THEME.textSecondary,
          margin: '8px 0 0',
        }}
      >
        <FormattedMessage
          id="marketerView.explore.intro"
          defaultMessage="This view of your score focuses on the impact of customers' feelings about different parts of your brand."
        />
      </p>
    </div>
    {data.themes.map((t) => (
      <ThemeSection key={t.id} theme={t} onOpen={onOpen} />
    ))}
  </main>
);
